import React from 'react';
import styled from 'styled-components';
import servicesData from './data';
import ServiceComp from './ServiceComp';
import ServicesBanner from './ServicesBanner';

const Services = () => {
    return (
        <div>
            <ServicesBanner />
            <Container>
                <div className="heading">
                    <span>Our Services</span>
                    <h4>Always At Your Service</h4>
                    <p>From research to vision to implementation, DemiGod group translates bold ideas into industry-leading web applications that advance your business. Our professional services ensure the digital products we produce set a high water mark for engagement, efficiency, and elegance</p>
                </div>
                {servicesData.map((item, index) => (
                    <ServiceComp
                        item={item}
                        index={index}
                    />
                ))}
            </Container>
        </div>
    )
}

export default Services


const Container = styled.div`
    /* height: 1000vh; */
    background: white;
    margin-bottom: -4rem;
    padding-bottom: 2rem;
    .heading{
        text-align: center;
        padding: 0rem 10rem;
        padding-bottom: 2rem;
        span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
        }
        h4{
            color: #000219;
            font-size: 2rem;
            font-weight: 800;
        }
        p{
            color: #000219;
            font-size: 1.2rem;
        }
        @media screen and (max-width: 900px){
            padding: 0rem 1rem;
            h4{
                font-size: 1rem;
            }
        }
    }
`